import { mapRelationalValue, RelationalValue } from "../../utils";
import { createApiMutationHook, IApiMutationFunction } from "../../utils/api";
import { IResourceResource } from "../types";

export type IResourceDeleteMutationParameters = {
    resource: RelationalValue<IResourceResource>;
};

export type IResourceDeleteMutationResult = void;

export const resourceDeleteMutation: IApiMutationFunction<IResourceDeleteMutationParameters> = ({ resource }) => {
    return {
        method: "DELETE",
        url: `/resources/${mapRelationalValue(resource)}`,
    };
};

export const useResourceDeleteMutation = createApiMutationHook<
    IResourceDeleteMutationParameters,
    IResourceDeleteMutationResult
>(resourceDeleteMutation);
